module.exports = __webpack_public_path__ + "img/box4.30afd307.png";